import { ReactNode } from 'react'
import clsx from 'clsx'

/* blocks */
import Seo from '@/molecules/SEO/SEO'
import Header from '@/molecules/Header/CML/Header'
import PromotionalBanner from '@/molecules/PromotionalBanner/PromotionalBanner'
import CMLFooter from '@/molecules/Footer/CMLFooter'

/* utils */
import { inter, interLocal } from '@/styles/fonts/fonts'

interface Meta {
  property: string
  content: string
}

interface Props {
  children: ReactNode
  title: string
  meta?: Meta[]
  canonical?: string
  jsonSchema?: LDJsonSchema[]
  noIndex?: boolean
}

const leaderLinkList = [
  {
    id: '1',
    title: 'Global leaders',
    href: '/global-marketing-leaders/leader/global/'
  },
  {
    id: '2',
    title: 'Indian leaders',
    href: '/global-marketing-leaders/leader/indian/'
  },
  {
    id: '3',
    title: 'All leaders',
    href: '/global-marketing-leaders/leader'
  }
]

function Layout({
  title,
  meta,
  children,
  canonical = '',
  jsonSchema,
  noIndex = false
}: Props) {
  return (
    <div className={clsx(inter.className, interLocal.variable)}>
      <Seo
        title={title}
        meta={meta}
        canonical={canonical}
        jsonSchema={jsonSchema}
        noIndex={noIndex}
      />
      <PromotionalBanner />
      <Header leaderLinkList={leaderLinkList} />
      <main data-test-id="main">{children}</main>
      <CMLFooter />
    </div>
  )
}

export default Layout
